__turbopack_context__.v({
  "activeThumbnail": "gallery-module__tqeQcW__activeThumbnail",
  "canvas": "gallery-module__tqeQcW__canvas",
  "caption": "gallery-module__tqeQcW__caption",
  "close": "gallery-module__tqeQcW__close",
  "control": "gallery-module__tqeQcW__control",
  "controls": "gallery-module__tqeQcW__controls",
  "cover": "gallery-module__tqeQcW__cover",
  "fullImage": "gallery-module__tqeQcW__fullImage",
  "inactiveThumbnail": "gallery-module__tqeQcW__inactiveThumbnail",
  "mainPhoto": "gallery-module__tqeQcW__mainPhoto",
  "minWidth": "gallery-module__tqeQcW__minWidth",
  "moreCount": "gallery-module__tqeQcW__moreCount",
  "moreShade": "gallery-module__tqeQcW__moreShade",
  "mosaic": "gallery-module__tqeQcW__mosaic",
  "mosaicGrid": "gallery-module__tqeQcW__mosaicGrid",
  "next": "gallery-module__tqeQcW__next",
  "overlay": "gallery-module__tqeQcW__overlay",
  "previewBody": "gallery-module__tqeQcW__previewBody",
  "previewButton": "gallery-module__tqeQcW__previewButton",
  "previewClose": "gallery-module__tqeQcW__previewClose",
  "previewDescription": "gallery-module__tqeQcW__previewDescription",
  "previewDialog": "gallery-module__tqeQcW__previewDialog",
  "previewHeader": "gallery-module__tqeQcW__previewHeader",
  "previewImage": "gallery-module__tqeQcW__previewImage",
  "previewThumb": "gallery-module__tqeQcW__previewThumb",
  "previewTitle": "gallery-module__tqeQcW__previewTitle",
  "previous": "gallery-module__tqeQcW__previous",
  "sidePhoto": "gallery-module__tqeQcW__sidePhoto",
  "sidePhotos": "gallery-module__tqeQcW__sidePhotos",
  "single": "gallery-module__tqeQcW__single",
  "stage": "gallery-module__tqeQcW__stage",
  "strip": "gallery-module__tqeQcW__strip",
  "thumbImage": "gallery-module__tqeQcW__thumbImage",
  "thumbnail": "gallery-module__tqeQcW__thumbnail",
  "thumbnails": "gallery-module__tqeQcW__thumbnails",
  "toolbar": "gallery-module__tqeQcW__toolbar",
  "zoomLabel": "gallery-module__tqeQcW__zoomLabel",
});
